export default "__VITE_ASSET__1903f38f__"